import { schemaComponentIdForRuntimeComponent } from './component-aliases';
export const GENERIC_RUNTIME_PASSTHROUGH_PROP_NAMES = new Set([
    'id',
    'className',
    'style',
    'ref',
    'role',
    'tabIndex',
    'htmlFor',
    'for',
    'data',
    'ariaLabel',
    'ariaLabelledBy',
    'ariaDescribedBy',
    'ariaHidden',
    'ariaOrientation',
    'ariaInvalid',
    'ariaErrorMessage',
    'ariaDisabled',
    'aria-current',
    'aria-hidden',
    'onClick',
    'onMouseEnter',
    'onMouseLeave',
    'onMouseDown',
    'onContextMenu',
    'onFocus',
    'onBlur',
    'onKeyDown',
    'onDragStart',
    'onDragEnd',
    'onDragEnter',
    'onDragOver',
    'onDragLeave',
    'onDrop',
    'onInput',
    'onChange',
    '_hover',
    '_focus',
    '_active',
]);
const FLEX_LAYOUT_INTERACTIVE_HOST_PROP_NAMES = new Set(['disabled', 'type', 'form', 'name', 'value']);
const RUNTIME_HOST_ALLOWED_PROP_NAMES_BY_TAG = Object.freeze({
    a: new Set(['href', 'target', 'rel']),
    button: new Set(FLEX_LAYOUT_INTERACTIVE_HOST_PROP_NAMES),
    source: new Set(['src', 'type']),
    video: new Set([
        'src',
        'type',
        'preload',
        'poster',
        'controls',
        'autoPlay',
        'autoplay',
        'muted',
        'loop',
        'playsInline',
        'playsinline',
    ]),
});
const DROPDOWN_MENU_ITEM_AUTHORING_PROP_NAMES = new Set([
    'endElement',
    'shortcut',
    'startElement',
]);
export const SUPPLEMENTAL_RUNTIME_ALLOWED_PROP_NAMES_BY_COMPONENT = Object.freeze({
    TabsTrigger: new Set(['type']),
    TabsContent: new Set(['hidden', 'inert']),
    Box: new Set(['as']),
    BreadcrumbCurrentLink: new Set(['type']),
    BreadcrumbEllipsis: new Set(['type']),
    BreadcrumbItem: new Set(['type']),
    BreadcrumbLink: new Set(['rel', 'type']),
    BreadcrumbList: new Set(['type']),
    BreadcrumbSeparator: new Set(['type']),
    Checkbox: new Set(['type']),
    Divider: new Set(['as']),
    DropdownMenu: new Set(['onOpenChange']),
    DropdownMenuCheckboxItem: new Set(['onCheckedChange', 'onSelect', ...DROPDOWN_MENU_ITEM_AUTHORING_PROP_NAMES]),
    DropdownMenuItem: new Set(['onSelect', ...DROPDOWN_MENU_ITEM_AUTHORING_PROP_NAMES]),
    DropdownMenuRadioGroup: new Set(['onValueChange']),
    DropdownMenuRadioItem: new Set(['onSelect', ...DROPDOWN_MENU_ITEM_AUTHORING_PROP_NAMES]),
    DropdownMenuSub: new Set(['onOpenChange']),
    DropdownMenuSubTrigger: new Set(DROPDOWN_MENU_ITEM_AUTHORING_PROP_NAMES),
    DropdownMenuTrigger: new Set(['type']),
    Flex: new Set(['as', ...FLEX_LAYOUT_INTERACTIVE_HOST_PROP_NAMES]),
    Grid: new Set(['as']),
    GridItem: new Set(['as']),
    Link: new Set(['rel']),
    Radio: new Set(['type']),
    Select: new Set(['type']),
    Spacer: new Set(['as']),
    Switch: new Set(['type']),
    StackRow: new Set(['as', ...FLEX_LAYOUT_INTERACTIVE_HOST_PROP_NAMES]),
    Stack: new Set(['as', ...FLEX_LAYOUT_INTERACTIVE_HOST_PROP_NAMES]),
    StackCol: new Set(['as', ...FLEX_LAYOUT_INTERACTIVE_HOST_PROP_NAMES]),
});
export function isSupplementalRuntimeAllowedPropName(componentType, propName) {
    const canonicalType = schemaComponentIdForRuntimeComponent(componentType);
    return Boolean(SUPPLEMENTAL_RUNTIME_ALLOWED_PROP_NAMES_BY_COMPONENT[componentType]?.has(propName)
        || SUPPLEMENTAL_RUNTIME_ALLOWED_PROP_NAMES_BY_COMPONENT[canonicalType]?.has(propName));
}
export function isRuntimeHostAllowedPropName(hostType, propName) {
    return Boolean(RUNTIME_HOST_ALLOWED_PROP_NAMES_BY_TAG[hostType]?.has(propName));
}
//# sourceMappingURL=runtime-prop-allowances.js.map